import { render } from "./LoginActualizarClave.vue?vue&type=template&id=6d292b61&scoped=true"
import script from "./LoginActualizarClave.vue?vue&type=script&lang=js"
export * from "./LoginActualizarClave.vue?vue&type=script&lang=js"

import "./LoginActualizarClave.vue?vue&type=style&index=0&id=6d292b61&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d292b61"]])

export default __exports__